import i18nCountriesConfig from '@active/core/address/i18nAddressConfig/i18nCountriesConfig.json'

export default Object.entries(i18nCountriesConfig).reduce((res, [key, value]) => {
  res.push({ ...value, code: key })
  return res
}, [])
